module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-571d8738.png";